<template>
  <div ref="pdfContainer" id="ContractPDF" class="form-control p-0">
    <vue-pdf-embed v-if="pdfSource" :source="pdfSource" :width="pdfWidth" @loaded="tryViewContract"/>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
import { ErrorHelper } from '@/helpers/ErrorHelper'
import { ClientOnboardingInviteCacheMixin } from '@/mixins/Registration/ClientOnboardingInviteCacheMixin'
import { WebApi } from '@/services/WebApi'
import VuePdfEmbed from 'vue-pdf-embed/dist/vue2-pdf-embed'

export default {
  name: 'PdfContainer',
  mixins: [ClientOnboardingInviteCacheMixin],
  data () {
    return {
      error: '',
      loading: false,
      pdfSource: '',
      pdfWidth: 0
    }
  },
  methods: {
    ...mapMutations('ClientOnboardingInvites', [
      'setContractCompleted'
    ]),
    tryFetchPdf () {
      const self = this
      if (self.loading) {
        return
      }
      self.error = ''
      self.loading = true
      WebApi.get('ClientOnboardingInvite/' + self.inviteId + '/Contract/Pdf')
        .then(response => {
          self.pdfSource = 'data:application/pdf;base64,' + response.data
          self.setPdfWidth()
        })
        .catch(error => {
          if (ErrorHelper.isNotFound(error)) {
            self.afterFetchPdf()
          } else {
            self.error = ErrorHelper.getError(error)
          }
        })
        .finally(() => { self.loading = false })
    },
    afterFetchPdf () {
      this.setContractCompleted()
    },
    tryViewContract () {
      const self = this
      if (self.loading) {
        return
      }
      self.error = ''
      self.loading = true
      WebApi.put('ClientOnboardingInvite/' + self.inviteId + '/Contract/View')
        .catch(error => {
          if (ErrorHelper.isNotFound(error)) {
            self.tryFetchClientOnboardingInvite()
          } else {
            self.error = ErrorHelper.getError(error)
          }
        })
        .finally(() => {
          self.loading = false
        })
    },
    setPdfWidth () {
      this.$nextTick(() => {
        const container = this.$refs.pdfContainer
        if (container) {
          this.pdfWidth = container.getBoundingClientRect().width
        }
      })
    }
  },
  mounted () {
    this.$nextTick(() => { this.setPdfWidth() })
    window.addEventListener('resize', this.setPdfWidth)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.setPdfWidth)
  },
  created () {
    this.tryFetchPdf()
  },
  components: {
    VuePdfEmbed
  }
}
</script>

<style scoped>
#ContractPDF {
  overflow: auto;
  height: 80vh !important;
  width: 100%;
  overflow-x: hidden;
}

@media screen and (max-width: 768px) {
  #ContractPDF {
    height: 80vh !important;
  }
}
</style>
